import { privacyPolicyHTML } from "./texts";
import PolicyPage from "./PolicyPage";

export default function PrivacyPolicy() {
  return (
    <PolicyPage
      html={privacyPolicyHTML}
      title="Privacy Policy — ThriveOn Calorie Tracker"
      description="How ThriveOn collects, uses and protects your personal information when you use the ThriveOn calorie tracker app."
      path="/privacy-policy"
    />
  );
}
